class ProductSponsorListElement extends HTMLElement {
    constructor() {
        super();

        this.selectedVariantsArray = [];
        this.fetchedPrices = null;
        this.fetchedSizePrices = [];
        this.collectionCartName = '';
        this.showPrices = false;
        this.accountCanOrder = false;

        this.idElement = this.attributes.getNamedItem('id').value;
        this.currencySymbol = '';
        this.buttonCart = this.querySelector('.errea_button');
        this.selectedCustomer = localStorage.getItem('errea_selectedCustomer')
            ? JSON.parse(localStorage.getItem('errea_selectedCustomer'))
            : null;

        if (this.selectedCustomer) {
            const accountType = window.errea_accountUserData.accountType;
            if (accountType && accountType != 'Catalog') {
                this.accountCanOrder = true;
                if (!localStorage.getItem('errea_hidePrices')) this.showPrices = true;
            }
        }

        this.waitData();
        this.addEventListener('submit', this.addToCart);
        this.translations = document.querySelector('#translationsObject')
            ? JSON.parse(document.querySelector('#translationsObject').innerHTML)
            : null;

        this.asyncLocalStorage = {
            setItem: function (key, value) {
                return Promise.resolve().then(function () {
                    localStorage.setItem(key, value);
                });
            },
            getItem: function (key) {
                return Promise.resolve().then(function () {
                    return localStorage.getItem(key);
                });
            },
        };
    }

    checkIfSoldOverQuantity(variant) {
        if (variant) {
            const deliveryPeriod = variant.querySelector('.recap input[name="deliveryPeriod"]')
                ? variant.querySelector('.recap input[name="deliveryPeriod"]').value
                : null;
            if (deliveryPeriod && (deliveryPeriod == 'FC0' || deliveryPeriod == 'PE0' || deliveryPeriod == 'R00')) {
                return false;
            }
            if (deliveryPeriod == 'SP0' || deliveryPeriod == 'CA0') {
                const pfsDeliveryItem = variant.querySelector('.recap input[name="pfsDeliveryItem"]')
                    ? variant.querySelector('.recap input[name="pfsDeliveryItem"]').value
                    : null;
                if (pfsDeliveryItem && pfsDeliveryItem == 'false') {
                    return true;
                }
                return false;
            }
            return false;
        }
    }

    checkMaxQuantity() {
        if (this.selectedVariantsArray.length > 0) {
            for (const variant of this.selectedVariantsArray) {
                const variantElement = this.querySelector(`#variant_${variant.id}`);
                const isSoldOverQuantity = this.checkIfSoldOverQuantity(variantElement);
                if (variant.quantity > variant.max && !isSoldOverQuantity) {
                    this.buttonCart.disabled = true;
                    return;
                } else {
                    this.buttonCart.disabled = false;
                }
            }
        }
    }

    convertNumberToCurrency = (price) => {
        const formatter = new Intl.NumberFormat('it-IT', {
            style: 'decimal',
            minimumFractionDigits: 2,
        });
        return `${formatter.format(price)}`;
    };

    getCartCurrentLine() {
        const cartData = JSON.parse(localStorage.getItem('errea_cartProducts'));
        if (cartData) return cartData.items.length + 1;
        else return 1;
    }

    getVariantOptions = (size, color, style) => {
        const variantOptions = [];

        if (style) {
            variantOptions.push({
                name: 'Stile',
                value: style,
            });
        }
        if (size) {
            variantOptions.push({
                name: 'Taglia',
                value: size,
            });
        }
        if (color) {
            variantOptions.push({
                name: 'Colore',
                value: color,
            });
        }
        return variantOptions;
    };

    updateAllInputs(products) {
        const allVariants = this.querySelectorAll('.variant');
        for (const variant of allVariants) {
            const quantityInput = variant.querySelector('input[name="quantity"]');
            if (quantityInput) {
                const sku = variant.getAttribute('sku') ?? null;
                if (sku) {
                    const foundProduct = products.find((product) => product.sku == sku);
                    if (foundProduct) {
                        const maxValue = quantityInput.getAttribute('max') ?? null;
                        let newMaxValue;
                        if (maxValue !== null) {
                            newMaxValue = parseInt(maxValue) - parseInt(foundProduct.quantity);
                        } else {
                            const quantityString = variant.querySelector('.recap .quantity')
                                ? variant.querySelector('.recap .quantity').innerText.split(' ')[0]
                                : null;
                            newMaxValue = parseInt(quantityString) - parseInt(foundProduct.quantity);
                        }
                        this.selectedVariantsArray = this.selectedVariantsArray.map((selectedVariant) => {
                            if (selectedVariant.id == foundProduct.id) {
                                return {
                                    ...selectedVariant,
                                    max: newMaxValue,
                                };
                            }
                            return selectedVariant;
                        });
                        const isSoldOverQuantity = this.checkIfSoldOverQuantity(variant);
                        if (!isSoldOverQuantity) {
                            quantityInput.setAttribute('max', newMaxValue);
                        }
                        const quantityElement = variant.querySelector('.recap .quantity');
                        if (quantityElement) {
                            if (newMaxValue == 0 && !isSoldOverQuantity) {
                                quantityInput.setAttribute('disabled', true);
                            }
                            if (newMaxValue < 200) {
                                if (!isSoldOverQuantity)
                                    quantityElement.innerHTML = `${newMaxValue >= 0 ? newMaxValue : 0} ${
                                        this.translations ? this.translations.pz : 'pz'
                                    }`;
                            } else {
                                if (!isSoldOverQuantity)
                                    quantityElement.innerHTML = `200+ ${
                                        this.translations ? this.translations.pz : 'pz'
                                    }`;
                            }
                        }
                    }
                }
                quantityInput.value = '';
            }
        }
        const totalValue = this.querySelector('#totalValue');
        if (totalValue) {
            totalValue.innerHTML = '0';
        }
        let items = [];
        this.selectedVariantsArray.map((item) => {
            items.push({
                id: item.id,
                quantity: 0,
                max: item.max,
                min: item.minValue,
            });
        });
        this.selectedVariantsArray = items;
    }

    async addToCart(event) {
        event.preventDefault(); // Update to create an object based on the multiple input rows
        let items = [];
        const rows = this.querySelectorAll('.variants_row .variant');

        for (const row of rows) {
            const productId = parseInt(row.querySelector('[name="productId"]').value);
            const productCategory = row.querySelector('[name="productCategory"]').value;
            const productCode = row.querySelector('[name="productCode"]').value;
            const productTitle = row.querySelector('[name="productTitle"]').value;
            const productBrand = row.querySelector('[name="productBrand"]').value;

            const id = parseInt(row.querySelector('[name="id"]').value);
            const qty = parseInt(row.querySelector('[name="quantity"]').value); // We don't care about any rows with a quantity of 0
            const max = parseInt(row.querySelector('[name="quantity"]').getAttribute('max'));
            const sku = row.querySelector('[name="sku"]').value;
            const size = row.querySelector('[name="size"]').value;
            const color = row.querySelector('[name="color"]').value;
            const style = row.querySelector('[name="style"]').value;

            const image = row.querySelector('[name="image"]').value;
            const url = row.querySelector('[name="url"]').value;

            const deliveryPeriod = row.querySelector('[name="deliveryPeriod"]').value;
            const pfsDeliveryItem = row.querySelector('[name="pfsDeliveryItem"]').value == 'true' ? true : false;

            // const shipmentDate = row.querySelector('[name="shipmentDate"]').value;
            // const createdAt = row.querySelector('[name="createdAt"]').value;

            const line = this.getCartCurrentLine();
            const options = this.getVariantOptions(size, color, style);

            let prices = null;

            if (this.fetchedSizePrices.length) {
                const findedPrice = this.fetchedSizePrices.find((price) => price.style == style);
                if (findedPrice) prices = findedPrice.price;
            } else {
                prices = this.fetchedPrices;
            }
            if (id && qty > 0) {
                items.push({
                    id: id,
                    quantity: qty,
                    max: max ? max : null,
                    line: line,
                    key: `${id}:${Math.floor(Date.now() / 1000)}`,
                    productId: productId,
                    variantId: id,
                    url: url,
                    title: productTitle,
                    sku: sku,
                    price: '0',
                    total: '0',
                    category: 'errea-1',
                    productType: productCategory,
                    code: productCode,
                    cart: 'sponsor',
                    fetchedPrices: prices ?? null,
                    collectionName: this.collectionCartName,
                    campaignCode: '',
                    promoCode: '',
                    brandName: productBrand,
                    shipments: '',
                    featuredImage: image,
                    options: options,
                    deliveryPeriod: deliveryPeriod,
                    pfsDeliveryItem: pfsDeliveryItem,
                    shipmentDate: null,
                    createdAt: Math.floor(Date.now() / 1000),
                });
            }
        }

        if (!items.length) {
            // Do something to tell the customer that there's nothing to add if all quantities were 0
            // Select variants row and flash red
            let qtyInputs = this.querySelector('.variants_row');
            let atcBtn = this.querySelector('.add_to_cart_container .errea_button');
            const qtyErrorMsg = document.createElement('span');

            qtyErrorMsg.innerText = 'Seleziona una quantità';
            qtyErrorMsg.style = `
                display: block;
                align-items: center;
                padding: 1rem;
                color: red;
                font-size: 1.4rem;
                position: absolute;
                left: ${atcBtn.offsetLeft + 8}px;
                top: ${atcBtn.offsetTop - 42}px;
            `;
            atcBtn.insertAdjacentElement('beforebegin', qtyErrorMsg);

            qtyInputs.classList.add('input-field-error');
            atcBtn.classList.add('qty-error');
            window.setTimeout(() => {
                qtyInputs.classList.remove('input-field-error');
                atcBtn.classList.remove('qty-error');
                qtyErrorMsg.remove();
            }, 3000);
            return;
        }

        if (localStorage.getItem('errea_checkoutProducts')) {
            localStorage.removeItem('errea_checkoutProducts');
        }

        const cartData = localStorage.getItem('errea_cartProducts');

        let products = cartData ? JSON.parse(cartData).items : items;

        if (cartData) {
            items.forEach((item) => {
                const finded = products.findIndex((product) => product.id == item.id && product.cart == 'sponsor');
                if (finded != -1) {
                    products[finded].quantity += item.quantity;
                } else {
                    products.push(item);
                }
            });
        }
        this.asyncLocalStorage
            .setItem(
                'errea_cartProducts',
                JSON.stringify({
                    currency: this.selectedCustomer.currencyCode ?? 'EUR',
                    items: products,
                }),
            )
            .then(() => {
                // Open cart notification
                const cartNotificationCustom = document.querySelector('cart-notification-custom');
                cartNotificationCustom.renderContents(items);
                const buttonNotification = cartNotificationCustom.querySelector(
                    '.cart-notification__links .errea_button',
                );
                if (buttonNotification) {
                    buttonNotification.href = `${
                        window.errea_accountUserData.language != 'it' ? `/${window.errea_accountUserData.language}` : ''
                    }/cart#sponsor`;
                }
                // Select errea cart counter
                const erreaCartCounter = document.querySelector(
                    `a.cartButton[href="${
                        window.errea_accountUserData.language != 'it' ? `/${window.errea_accountUserData.language}` : ''
                    }/cart#sponsor"].sponsor .count`,
                );
                // Get current cart quantity
                const productCount = parseInt(erreaCartCounter.innerText.split(' ')[1]);
                // Write updated quantity
                erreaCartCounter.innerHTML =
                    '/ ' + (productCount + items.reduce((acc, item) => acc + item.quantity, 0));
                this.updateAllInputs(items);
                saveCart(products);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    getKeyLines(data, checkArr) {
        var linesObj = {};
        var getAllKeys = Object.keys(data);

        checkArr.forEach(function (item) {
            getAllKeys.forEach(function (keyName) {
                if (keyName.indexOf(item) !== -1) {
                    linesObj[keyName] = data[keyName];
                }
            });
        });
        return linesObj;
    }

    async handleInventoryApi(variantSize, variantSku) {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');

        const productData = {
            itemNo: variantSku,
            variantCode: variantSize,
        };

        const requestOptions = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(productData),
            redirect: 'follow',
        };

        const response = await fetch(`/apps/errea/products/inventory_availability`, requestOptions);
        const data = await response.json();
        return data;
    }

    async checkTotalQuantity(variant, max, min) {
        let id = variant.querySelector('[name="id"]').value;
        const quantity = variant.querySelector('[name="quantity"]');
        const minValue = parseInt(min);
        this.selectedVariantsArray.push({
            id: id,
            quantity: 0,
            max: max >= 0 ? max : null,
            min: minValue,
        });
        const isSoldOverQuantity = this.checkIfSoldOverQuantity(variant);
        if (max == 0 && !isSoldOverQuantity) {
            quantity.setAttribute('disabled', true);
        }
        quantity.addEventListener('change', (evt) => {
            const value = evt.currentTarget.value ? parseInt(evt.currentTarget.value) : 0;
            const variantFound = this.selectedVariantsArray.find((v) => v.id == id);
            if (variantFound) {
                const variantElement = quantity.parentNode;
                const isSoldOverQuantity = this.checkIfSoldOverQuantity(variantElement);
                variantFound.quantity = value;
                let total = 0;

                let inputQtyData = 0;

                if (minValue > 0) {
                    let delta = value / minValue;
                    inputQtyData = min * Math.ceil(delta);
                } else {
                    inputQtyData = value;
                }

                if (variantElement.querySelector('[name="quantity"]'))
                    variantElement.querySelector('[name="quantity"]').value = inputQtyData;

                this.selectedVariantsArray.forEach((v) => {
                    if (v.quantity <= v.max || v.max == null || max == null) {
                        let qtyData = 0;

                        if (minValue > 0) {
                            let delta = v.quantity / minValue;
                            qtyData = min * Math.ceil(delta);
                        } else {
                            qtyData = v.quantity;
                        }
                        total += qtyData;
                    }
                });

                if (value > variantFound.max && !isSoldOverQuantity) {
                    quantity.classList.add('error');
                } else {
                    if (quantity.classList.contains('error')) {
                        quantity.classList.remove('error');
                    }
                    this.querySelector('#totalValue').innerHTML = total ? total : 0;
                }
                this.checkMaxQuantity();
            }
        });
    }

    async getProductPriceDiscount() {
        const variants = this.querySelectorAll('.variant');
        const variantSku = variants[0].getAttribute('sku');

        let styleList = [];

        variants.forEach((variant) => {
            if (!styleList.find((item) => item.style == variant.getAttribute('style'))) {
                let obj = {
                    style: variant.getAttribute('style'),
                    sku: variant.getAttribute('sku'),
                    size: variant.getAttribute('size'),
                };
                styleList.push(obj);
            }
        });
        for (const [index, style] of styleList.entries()) {
            if (style.sku && style.size) {
                const headers = new Headers();
                headers.append('Content-Type', 'application/json');
                let accountId = window.errea_accountUserData.accountCode;
                if (this.selectedCustomer && window.errea_accountUserData.accountType != 'Customer') {
                    accountId = this.selectedCustomer.customerNo;
                }
                let bcSku = style.sku.split('-');
                const productData = {
                    accountNo: accountId,
                    itemNo: bcSku.length ? bcSku[0] : style.sku,
                    variantCode: style.size,
                    orderTypeCode: 'VENDI',
                };

                const requestOptions = {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify(productData),
                    redirect: 'follow',
                };
                try {
                    const priceRow = this.querySelector('.price_row');
                    if (priceRow) {
                        if (localStorage.getItem('errea_hidePrices')) {
                            priceRow.classList.add('hide');
                        }
                        const resultPrice = !window.errea_accountUserData.hidePrice
                            ? await fetch(`/apps/errea/products/calculated_price`, requestOptions)
                                  .then((response) => response.json())
                                  .catch((error) => {
                                      throw error ? error : 'error';
                                  })
                            : {
                                  value: {
                                      discountAmount: 0,
                                      discountPercent: 0,
                                      lineDiscountPerc1: 0,
                                      lineDiscountPerc2: 0,
                                      lineDiscountPerc3: 0,
                                      lineDiscountPerc4: 0,
                                      lineDiscountPerc5: 0,
                                      lineDiscountPerc6: 0,
                                      lineDiscountPerc7: 0,
                                      lineDiscountPerc8: 0,
                                      listPrice: 0,
                                      price: 0,
                                  },
                              };
                        if (resultPrice && resultPrice.value) {
                            if (styleList.length > 1 && !localStorage.getItem('errea_hidePrices')) {
                                if (index == 0) {
                                    const priceRowElement = document.querySelector(`#${this.idElement} .price_row`);
                                    const priceComponentElement = priceRowElement.querySelector('.price_component');
                                    let styleComponent = priceComponentElement.querySelector('#variantStyle');
                                    let finalPriceElement = priceComponentElement.querySelector('#finalPrice');
                                    let comparePriceELement = priceComponentElement.querySelector('#comparePrice');

                                    const styleKey = style.style;
                                    const priceObj = {
                                        style: styleKey,
                                        price: resultPrice.value,
                                    };
                                    this.fetchedSizePrices.push(priceObj);
                                    this.fetchedPrices = resultPrice.value;
                                    styleComponent.innerHTML = style.style;
                                    finalPriceElement.innerHTML = `${
                                        this.currencySymbol
                                    } ${this.convertNumberToCurrency(resultPrice.value.listPrice)}`;
                                    if (resultPrice.value.listPrice == resultPrice.value.price) {
                                        comparePriceELement.style.display = 'none';
                                    } else {
                                        comparePriceELement.innerHTML = `${
                                            this.currencySymbol
                                        } ${this.convertNumberToCurrency(resultPrice.value.price)}`;
                                        finalPriceElement.classList.add('promo');
                                    }
                                    if (priceComponentElement.classList.contains('loading')) {
                                        priceComponentElement.classList.remove('loading');
                                    }

                                    const discountLines = this.getKeyLines(resultPrice.value, ['lineDiscount']);
                                    if (discountLines) {
                                        const discountArr = Array.isArray(discountLines)
                                            ? discountLines
                                            : Object.values(discountLines);
                                        const defaultString = this.translations
                                            ? this.translations.value_sale
                                            : 'Sconto del';
                                        let discountString = defaultString;
                                        discountArr.forEach((discount) => {
                                            if (discount > 0) {
                                                if (discountString === defaultString) {
                                                    discountString += ` ${discount}%`;
                                                } else {
                                                    discountString += ` + ${discount}%`;
                                                }
                                            }
                                        });
                                        let saleDataElement = priceRowElement.querySelector('.sale_data');
                                        if (discountString === defaultString) {
                                            discountString = '';
                                            saleDataElement.style.display = 'none';
                                        } else {
                                            const discountSumString = saleDataElement.querySelector('#labelDiscount');
                                            const discountValue = saleDataElement.querySelector('#valueDiscount');
                                            discountSumString.innerHTML = discountString;
                                            discountValue.innerHTML = `${
                                                resultPrice.value.discountPercent % 1 !== 0
                                                    ? resultPrice.value.discountPercent.toFixed(2)
                                                    : resultPrice.value.discountPercent
                                            }%`;
                                        }

                                        if (saleDataElement.classList.contains('loading')) {
                                            saleDataElement.classList.remove('loading');
                                        }
                                    }
                                } else {
                                    const styleKey = style.style;
                                    const priceObj = {
                                        style: styleKey,
                                        price: resultPrice.value,
                                    };
                                    this.fetchedSizePrices.push(priceObj);
                                    this.fetchedPrices = resultPrice.value;

                                    const discountLines = this.getKeyLines(resultPrice.value, ['lineDiscount']);
                                    const defaultString = this.translations
                                        ? this.translations.value_sale
                                        : 'Sconto del';
                                    let discountString = defaultString;
                                    if (discountLines) {
                                        const discountArr = Array.isArray(discountLines)
                                            ? discountLines
                                            : Object.values(discountLines);
                                        discountArr.forEach((discount) => {
                                            if (discount > 0) {
                                                if (discountString === defaultString) {
                                                    discountString += ` ${discount}%`;
                                                } else {
                                                    discountString += ` + ${discount}%`;
                                                }
                                            }
                                        });
                                    }
                                    let html = [
                                        '<div class="price_row">',
                                        '<p class="price_component">',
                                        `<span class="meta" id="variantStyle">${style.style}</span>`,
                                        `<span class="price ${
                                            resultPrice.value.listPrice != resultPrice.value.price && 'promo'
                                        }" id="finalPrice">${this.currencySymbol} ${this.convertNumberToCurrency(
                                            resultPrice.value.listPrice,
                                        )}</span>`,
                                        resultPrice.value.listPrice == resultPrice.value.price
                                            ? ''
                                            : `<span class="compare_price" id="comparePrice">${
                                                  this.currencySymbol
                                              } ${this.convertNumberToCurrency(resultPrice.value.price)}</span>`,
                                        `<span class="measure">${
                                            this.translations ? this.translations.each : 'cad.'
                                        }</span>`,
                                        '</p>',
                                        discountString === defaultString ? '' : '<div class="sale_data">',
                                        discountString === defaultString
                                            ? ''
                                            : `<p class="label_sale" id="labelDiscount">${discountString}</p>`,
                                        discountString === defaultString
                                            ? ''
                                            : `<p class="sale" id="valueDiscount">${
                                                  resultPrice.value.discountPercent % 1 !== 0
                                                      ? resultPrice.value.discountPercent.toFixed(2)
                                                      : resultPrice.value.discountPercent
                                              }%</p>`,
                                        discountString === defaultString ? '' : '</div>',
                                        `<p class="tax">${
                                            this.translations ? this.translations.price_no_taxes : 'Prezzo iva esclusa'
                                        }</p>`,
                                        '</div>',
                                    ].join('');

                                    const rows = document.querySelectorAll(`#${this.idElement} .price_row`);

                                    rows[rows.length - 1].insertAdjacentHTML('afterend', html);
                                }
                            } else {
                                //Check prezzo da api
                                const priceComponentElement = document.querySelector(
                                    `#${this.idElement} .price_component`,
                                );
                                const finalPriceElement = priceComponentElement.querySelector('#finalPrice');
                                const comparePriceELement = priceComponentElement.querySelector('#comparePrice');
                                let styleComponent = priceComponentElement.querySelector('#variantStyle');

                                styleComponent.innerHTML = style.style;

                                this.fetchedPrices = resultPrice.value;

                                finalPriceElement.innerHTML = `${this.currencySymbol} ${this.convertNumberToCurrency(
                                    resultPrice.value.listPrice,
                                )}`;
                                if (resultPrice.value.listPrice == resultPrice.value.price) {
                                    comparePriceELement.style.display = 'none';
                                } else {
                                    comparePriceELement.innerHTML = `${
                                        this.currencySymbol
                                    } ${this.convertNumberToCurrency(resultPrice.value.price)}`;
                                    finalPriceElement.classList.add('promo');
                                }
                                if (priceComponentElement.classList.contains('loading')) {
                                    priceComponentElement.classList.remove('loading');
                                }
                                //Fine check prezzo da api

                                //Check scontistica applicata
                                const discountLines = this.getKeyLines(resultPrice.value, ['lineDiscount']);
                                if (discountLines) {
                                    const discountArr = Array.isArray(discountLines)
                                        ? discountLines
                                        : Object.values(discountLines);
                                    const defaultString = this.translations
                                        ? this.translations.value_sale
                                        : 'Sconto del';
                                    let discountString = defaultString;
                                    discountArr.forEach((discount) => {
                                        if (discount > 0) {
                                            if (discountString === defaultString) {
                                                discountString += ` ${discount}%`;
                                            } else {
                                                discountString += ` + ${discount}%`;
                                            }
                                        }
                                    });
                                    const saleDataElement = document.querySelector(`#${this.idElement} .sale_data`);
                                    if (discountString === defaultString) {
                                        discountString = '';
                                        saleDataElement.style.display = 'none';
                                    } else {
                                        const discountSumString = saleDataElement.querySelector('#labelDiscount');
                                        const discountValue = saleDataElement.querySelector('#valueDiscount');
                                        discountSumString.innerHTML = discountString;
                                        discountValue.innerHTML = `${
                                            resultPrice.value.discountPercent % 1 !== 0
                                                ? resultPrice.value.discountPercent.toFixed(2)
                                                : resultPrice.value.discountPercent
                                        }%`;
                                    }

                                    if (saleDataElement.classList.contains('loading')) {
                                        saleDataElement.classList.remove('loading');
                                    }
                                }
                                //Fine check scontistica applicata
                            }
                        } else {
                            throw resultPrice.error ? resultPrice.error.code : 'error';
                        }
                    }
                } catch (error) {
                    console.log(error);
                    const errorToastElement = document.querySelector('toast-error');
                    if (errorToastElement) {
                        errorToastElement.showToast();
                    }
                }
            }
        }

        if (variants && variantSku) {
            try {
                //Check quantità varianti
                for (const variant of variants) {
                    if (variant) {
                        const currentVariantSku = variant.getAttribute('sku');
                        const currentVariantSize = variant.getAttribute('size');

                        const quantityEl = variant.querySelector('[name="quantity"]');
                        let disableButton = true;
                        const [sku, size] = currentVariantSku.split('-');

                        const isSoldOverQuantity = this.checkIfSoldOverQuantity(variant);
                        const quantityResult = await this.handleInventoryApi(currentVariantSize, sku)
                            .then((quantityResult) => quantityResult)
                            .catch((error) => {
                                throw error ? error : 'error';
                            });

                        if (typeof quantityResult.value === 'number') {
                            let currentInCart = 0;
                            const productsInCart = localStorage.getItem('errea_cartProducts')
                                ? JSON.parse(localStorage.getItem('errea_cartProducts'))
                                : null;
                            if (productsInCart) {
                                const foundProduct = productsInCart.items.find(
                                    (product) => product.sku == currentVariantSku,
                                );
                                if (foundProduct) {
                                    currentInCart = foundProduct.quantity;
                                }
                            }
                            let maxValue = quantityResult.value - currentInCart;
                            if (maxValue == 0 && isSoldOverQuantity) {
                                maxValue = null;
                            }
                            if (quantityEl) {
                                quantityEl.setAttribute('max', maxValue);
                                if (isSoldOverQuantity) {
                                    quantityEl.removeAttribute('max');
                                }
                            }

                            const quantityElement = variant.querySelector('.recap .quantity');
                            if (quantityElement) {
                                if (maxValue < 200) {
                                    quantityElement.innerHTML = `${maxValue && maxValue >= 0 ? maxValue : 0} ${
                                        this.translations ? this.translations.pz : 'pz'
                                    }`;
                                } else {
                                    quantityElement.innerHTML = `200+ ${
                                        this.translations ? this.translations.pz : 'pz'
                                    }`;
                                }
                                quantityElement.classList.remove('loading');
                            }

                            if (quantityEl) {
                                if (maxValue == 0 && !isSoldOverQuantity) {
                                    quantityEl.setAttribute('disabled', true);
                                } else {
                                    quantityEl.removeAttribute('disabled');
                                    disableButton = false;
                                }
                                const minValue = quantityEl.getAttribute('min');
                                this.checkTotalQuantity(variant, isSoldOverQuantity ? null : maxValue, minValue);
                            }
                        }
                        const buttonElement = document.querySelector(`#${this.idElement} button`);
                        if (buttonElement) {
                            if (disableButton) {
                                buttonElement.setAttribute('disabled', true);
                            } else {
                                buttonElement.removeAttribute('disabled');
                            }
                        }
                    }
                }
                //Fine check quantità varianti
            } catch (error) {
                console.log(error);
                const errorToastElement = document.querySelector('toast-error');
                if (errorToastElement) {
                    errorToastElement.showToast();
                }
            }
        }
    }

    hidePurchaseElements() {
        const priceRows = this.querySelectorAll('.product_data .price_row');
        const atcContainer = this.querySelector('.add_to_cart_container');
        const quantitySpanElements = atcContainer.querySelectorAll('.variants_row .recap .quantity');
        const quantityInputElements = atcContainer.querySelectorAll('.variants_row input.quantity');
        const quantityTotal = atcContainer.querySelector('.final_column_container');
        const atcButton = atcContainer.querySelector('button[id^="ProductSubmitButton"]');
        [...priceRows, ...quantitySpanElements, ...quantityInputElements, quantityTotal, atcButton].forEach((el) => {
            if (el) el.style.display = 'none';
        });
    }

    async waitData() {
        this.currencySymbol = await getCurrencySymbol();
        const collectionNameElement = document.querySelector('#collectionName')
            ? JSON.parse(document.querySelector('#collectionName').innerHTML)
            : this.querySelector('input[name="productCollectionTitle"]')
            ? this.querySelector('input[name="productCollectionTitle"]').value
            : null;
        if (collectionNameElement) {
            this.collectionCartName = collectionNameElement.collectionName
                ? collectionNameElement.collectionName
                : collectionNameElement;
        }
        if (this.accountCanOrder == true) {
            await this.getProductPriceDiscount();
        } else {
            this.hidePurchaseElements();
        }
    }
}
customElements.define('product-sponsor-list-element', ProductSponsorListElement);
